"use_strict"

class Polylang {

	constructor () {
		this._frenchSiteLink  = document.querySelector('.lang-item-fr a')
		this._englishSiteLink = document.querySelector('.lang-item-en a')

		this._makeLanguageMenuAccessible()
	}

	/**
	 * @function _makeLanguageMenuAccessible
	 * @desc Add necessary title to language switcher's links
	 */
	_makeLanguageMenuAccessible () {
		const frenchTitle = i18n.frenchTitle
		const englishTitle = i18n.englishTitle
		this._frenchSiteLink.setAttribute('title', frenchTitle)
		this._englishSiteLink.setAttribute('title', englishTitle)
	}
}

export { Polylang }
